'use client';

import { useCartStore } from '@/ui/store/cart';
import React from 'react';
import { useCurrencyFormatter } from '@/ui/hooks/useCurrencyFormatter';
import { useTranslations } from 'next-intl';
import { twJoin } from 'tailwind-merge';
import { CartCheckoutButton } from '../BottomCheckoutButton/CartCheckoutButton';
import { CartValueSectionProps } from './types/CartValueSectionProps';

export function CartValueSection({ isOnCartPage = false }: CartValueSectionProps) {
  const t = useTranslations('CartValueSection');

  const { isEmpty, getTotalAfterDiscount } = useCartStore();
  const { formatCurrency } = useCurrencyFormatter();

  return (
    <div
      className={twJoin(
        isOnCartPage ? 'border-b border-neutral-10 pb-3 sm:pb-6 md:space-y-6 md:pb-10' : 'mt-3',
      )}
    >
      <p
        className={twJoin(
          'text-center text-xl font-bold',
          isOnCartPage && 'sm:text-3xl md:text-5xl',
        )}
      >
        {t('Your cart value is')} {formatCurrency(getTotalAfterDiscount())}
      </p>
      <div className="mt-1 flex justify-center">
        <p
          className={twJoin(
            'w-2/3 text-center text-sm',
            isOnCartPage && 'max-w-md sm:text-md md:text-2xl',
          )}
        >
          {t('Lorem Ipsum Optional text, string translation from weblate')}
        </p>
      </div>
      <CartCheckoutButton
        disabled={isEmpty()}
        className={twJoin('mt-4', isOnCartPage && 'mx-auto w-fit')}
      />
    </div>
  );
}
